import { createFileRoute } from "@tanstack/react-router";

import { Withdrawal } from "./-components/Withdrawal/WithdrawalFlow";

export const Route = createFileRoute("/_authenticated/trade/withdraw")({
  component: Withdrawal,
  context: () => ({ permissions: "trade.withdraw" }),
});
